function Empty() {

  return (
    <div>
    </div>
  )
}

export default Empty;